/* =================================================================
   Shared source of truth for the Kitxens AI Operating Team avatars.
   Order is canonical and must match:
   - The Operating Intelligence section on the homepage
   - The team grid on /ai-agents-for-restaurants
   - The "Kitxens Team:" mini row in the Footer
   Avatars are hosted on the legacy Wix CDN (same files used elsewhere).
   ================================================================= */
export const TEAM_AVATARS = [
  {
    key: 'rachel',
    name: 'Rachel',
    role: 'AI Receptionist',
    img:
      '/avatars/rachel.png',
  },
  {
    key: 'stan',
    name: 'Stan',
    role: 'Lead Generation',
    img:
      '/avatars/stan.png',
  },
  {
    key: 'eva',
    name: 'Eva',
    role: 'Operations',
    img: '/avatars/eva.png',
  },
  {
    key: 'sonny',
    name: 'Sonny',
    role: 'Social Media',
    img:
      '/avatars/sonny.png',
  },
  {
    key: 'penny',
    name: 'Penny',
    role: 'SEO Content',
    img:
      '/avatars/penny.png',
  },
  {
    key: 'linda',
    name: 'Linda',
    role: 'Legal',
    img: '/avatars/linda.png',
  },
];

// Backdrop accent per agent — used by the avatar ring in the Operating
// Intelligence section so the team reads as one ensemble, not six brands.
export const TEAM_THEMES = [
  { ring: 'from-[#F77F11] to-[#ff9b4a]', dot: 'bg-[#F77F11]', halo: 'shadow-[0_0_0_4px_rgba(247,127,17,0.18)]' },
  { ring: 'from-sky-400 to-sky-600',     dot: 'bg-sky-400',    halo: 'shadow-[0_0_0_4px_rgba(56,189,248,0.18)]' },
  { ring: 'from-emerald-400 to-emerald-600', dot: 'bg-emerald-400', halo: 'shadow-[0_0_0_4px_rgba(52,211,153,0.18)]' },
  { ring: 'from-amber-400 to-amber-600', dot: 'bg-amber-400', halo: 'shadow-[0_0_0_4px_rgba(251,191,36,0.18)]' },
  { ring: 'from-violet-400 to-violet-600', dot: 'bg-violet-400', halo: 'shadow-[0_0_0_4px_rgba(167,139,250,0.18)]' },
  { ring: 'from-rose-400 to-rose-600',   dot: 'bg-rose-400',   halo: 'shadow-[0_0_0_4px_rgba(251,113,133,0.18)]' },
];
